"use client";

import { motion } from "motion/react";
import { useInView } from "react-intersection-observer";

export default function ViaEmailContact() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="mt-5">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 1 }}
        className="text-center mt-16"
      >
        <p className="text-gray-600 mb-4">
          Vous préférez nous contacter directement ?
        </p>
        <motion.a
          href="mailto:contact@formly-app.fr"
          className="text-primary-600 font-semibold hover:text-primary-700 transition-colors inline-block"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          contact@formly-app.fr
        </motion.a>
      </motion.div>
    </section>
  );
}
